import { useEffect, useState } from 'react';
import { autorun } from 'mobx';
/**
 *
 * @param store
 * @returns {{language: *, brand: *}}
 */
export default function useCurrency(_a) {
    var currencyStore = _a.currencyStore, currencyList = _a.currencyList;
    var _b = useState({
        currenciesList: currencyList || []
    }), state = _b[0], setState = _b[1];
    function handleFetchError(err) {
        console.log(err);
    }
    useEffect(function () {
        if ((!currencyList || currencyList.length === 0) &&
            currencyStore.API_STATE == 'INITIAL') {
            currencyStore.fetch(handleFetchError);
        }
        autorun(function () {
            var currenciesList = currencyList;
            if (!currenciesList || currenciesList.length === 0) {
                currenciesList = currencyStore.currenciesList;
            }
            setState({
                currenciesList: currenciesList
            });
        });
    }, [currencyList, currencyStore]);
    return state;
}
//# sourceMappingURL=useCurrency.js.map